import React from "react";
import { Div } from "../../../../components/grid";
import {
  SideMenuItem,
  SideMenuSpacer,
  SideMenuImageItem,
} from "../SidemenuItems";

export default ({ activeSidemenu }) => (
  <Div>
    <SideMenuItem
      to="/fadoel"
      title="Fadøl"
      active={activeSidemenu === "Fad"}
      main
    />
    <SideMenuItem
      to="/fadoel/pilsner"
      title="Pilsner"
      active={activeSidemenu === "Pilsner"}
    />
    <SideMenuItem
      to="/fadoel/classic"
      title="Classic"
      active={activeSidemenu === "Classic"}
    />
    <SideMenuItem
      to="/fadoel/hvedeoel"
      title="Hvedeøl"
      active={activeSidemenu === "Hvede"}
    />
    <SideMenuItem
      to="/fadoel/ipa"
      title="IPA"
      active={activeSidemenu === "IPA"}
    />
    <SideMenuItem
      to="/fadoel/ale"
      title="Ale"
      active={activeSidemenu === "Ale"}
    />
    <SideMenuItem
      to="/fadoel/porter"
      title="Porter / Stout"
      active={activeSidemenu === "Porter"}
    />
    <SideMenuItem
      to="/fadoel/letoel"
      title="Alkoholfri & Letøl"
      active={activeSidemenu === "Let"}
    />
    <SideMenuItem
      to="/fadoel/cocktails-vin-cider"
      title="Cocktails, vin &amp; cider"
      active={activeSidemenu === "Cocktails"}
    />
    <SideMenuSpacer />
    <SideMenuItem
      to="/fadoel/priser"
      title="Fadølspriser"
      active={activeSidemenu === "Priser"}
    />
    <SideMenuItem
      to="/fadoel/billigt-fadoel"
      title="Billigt Fadøl"
      active={activeSidemenu === "Billigt"}
    />
    <SideMenuItem
      to="/fadoel/oktoberfest"
      title="Oktoberfest øl"
      active={activeSidemenu === "Oktoberfest"}
    />
    <SideMenuItem
      to="/fadoel/juleoel"
      title="Juleøl"
      active={activeSidemenu === "Jul"}
    />
    <SideMenuItem
      to="/fadoel/paaskebryg"
      title="Påskebryg"
      active={activeSidemenu === "Easter"}
    />
    <SideMenuItem
      to="/fadoel/dhl-fadoel"
      title="Fadøl til DHL Stafetten"
      active={activeSidemenu === "DHL"}
    />
    <SideMenuItem
      to="/fadoel/dansk-fadoel"
      title="Dansk fadøl"
      active={activeSidemenu === "Dansk"}
    />
    <SideMenuItem
      to="/fadoel/udenlandske-oel-paa-fad"
      title="Udenlandske fadøl"
      active={activeSidemenu === "Udenlandsk"}
    />
    <SideMenuItem
      to="/fadoel/modular-20"
      title="Modular 20"
      active={activeSidemenu === "Modular20"}
    />
    <SideMenuItem
      to="/fadoel/flex-20"
      title="Flex 20"
      active={activeSidemenu === "Flex20"}
    />
    <SideMenuSpacer />
    <SideMenuImageItem
      image="fadoelsanlaeg.fadoelsanlaeg.png"
      title="Leje af fadølsanlæg"
      to="/fadoelsanlaeg"
    />
  </Div>
);
